import { Injectable, OnDestroy } from '@angular/core';
import { FormArray, FormGroup, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { CheckoutValidationError, CheckoutValidationMessages } from './checkout-validation.messages';
import { CheckoutFormGroup } from '../checkout/checkout.component';


@Injectable({
    providedIn: "root"
})
export class CheckoutValidationService implements OnDestroy {

    public form: FormGroup;
    public errors: CheckoutValidationError[] = [];

    private validateSubject: BehaviorSubject<void> = new BehaviorSubject(null);
    public errorsSubject: BehaviorSubject<CheckoutValidationError[]> = new BehaviorSubject([]);

    public validate$ = this.validateSubject.asObservable().pipe(
      tap(() => this.getErrors(this.form))
    ).subscribe();

    public errors$: Observable<{[key: string]: string}> = this.errorsSubject.asObservable().pipe(
      map(errors => this.convertToMap(errors))
    );

    private setErrors(form: FormGroup | FormArray) {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            const hasChildren = control instanceof FormGroup || control instanceof FormArray;

            const controlErrors: ValidationErrors = control.errors;
            if (controlErrors !== null) {
                Object.keys(controlErrors).forEach(keyError => {
                    this.errors.push({
                        mapKey: hasChildren ? `${keyError}` : `${field}.${keyError}`,
                        value: controlErrors[keyError]
                    });
                });
            }

            if (hasChildren) {
              this.errors = this.errors.concat(this.setErrors(control));
          }
        });

        this.errors = this.errors.filter((error, index, self) => self.findIndex(t => t.mapKey === error.mapKey) === index);

        return this.errors;
    }

    public resetErrors() {
        this.errors = [];
    }

    public getErrors(form: FormGroup | FormArray): void {
        if (!form) {
          return;
        }
        this.resetErrors();
        this.setErrors(form);
        this.errorsSubject.next(this.errors);

    }

    public validate(form: FormGroup<CheckoutFormGroup>): void {
        this.form = form;
        this.validateSubject.next();
    }

    private convertToMap(errors: CheckoutValidationError[]): {[key: string]: string} {
      let map = {};
      errors.filter(error => error !== null).forEach(error => {
        // This is so that we can include errors that are defined in the my-cart effects
        // In the future we may not need to do this
        if(error.mapKey.includes('customError')){
          map[error.mapKey] = error.value;
        } else {
          map[error.mapKey] = CheckoutValidationMessages[error.mapKey] || null;
        }
      });
      return map;
    }

    ngOnDestroy(): void {
        this.validate$.unsubscribe();
    }
}

